import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Footer from './components/Footer';
import SearchResults from './components/SearchResults';
import DestinationPackages from './components/DestinationPackages';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <Features />
            </>
          } />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/destination/:destinationName" element={<DestinationPackages />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
